import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <a href="https://wa.me/46733874447"
      target="_blank" rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 rounded-full shadow-lg text-white text-sm font-medium transition-all hover:scale-105"
      style={{ backgroundColor: '#25D366' }}
      data-testid="whatsapp-btn">
      <MessageCircle size={20} />
      <span className="hidden sm:inline">Chatta med oss</span>
    </a>
  );
};

export default WhatsAppButton;
